module.exports = __webpack_public_path__ + "img/0S6A9488.b0aad976.jpg";